// prettier-ignore

import angular from 'angular';
import application from 'application/application';

import moment from 'moment';

application.service('integracaoGoogleCalendar', [
	'$http',
	'helper',
	'API',
	'$rootScope',
	'permissions',
	'$window',
	'notification',
	'authentication',
	'transformDate',
	'googleAPI',
	'environment',
	'$state',
	function(
		$http,
		helper,
		API,
		$rootScope,
		permissions,
		$window,
		notification,
		authentication,
		transformDate,
		googleAPI,
		environment,
		$state
	) {
		var client;

		const CLIENTID =
			environment.name === 'development'
				? googleAPI.development.clientID
				: googleAPI.production.clientID;
		const SCOPES =
			environment.name === 'development'
				? googleAPI.development.scopes
				: googleAPI.production.scopes;
		const GOOGLE_IDENTITY_SCRIPT = 'https://accounts.google.com/gsi/client';
		// Verifica os escopos concedidos pelo usuário
		const requiredScopes = [
			'https://www.googleapis.com/auth/calendar',
			'https://www.googleapis.com/auth/calendar.events',
			'https://www.googleapis.com/auth/userinfo.email',
			'https://www.googleapis.com/auth/tasks'
		];

		const url = {
			events: 'https://www.googleapis.com/calendar/v3/calendars/primary/events',
			tasks: 'https://tasks.googleapis.com/tasks/v1/lists/@default/tasks'
		};

		this.ensureGoogleIdentityLoaded = () => {
			if (
				$window.google &&
				$window.google.accounts &&
				$window.google.accounts.oauth2
			)
				return Promise.resolve();

			return new Promise((resolve, reject) => {
				const existingScript = document.querySelector(
					`script[src="${GOOGLE_IDENTITY_SCRIPT}"]`
				);

				if (existingScript) {
					existingScript.addEventListener('load', resolve, { once: true });
					existingScript.addEventListener('error', reject, { once: true });

					return;
				}

				const script = document.createElement('script');

				script.src = GOOGLE_IDENTITY_SCRIPT;
				script.async = true;
				script.defer = true;
				script.onload = resolve;
				script.onerror = reject;

				document.head.appendChild(script);
			});
		};

		this.permissionIntegracao = async () => {
			const permisao = await permissions.has('recordSchedule');

			const hasRecord = JSON.parse(localStorage.getItem('__DataGoogleSync__'));
			const sync = hasRecord ? hasRecord.sincronizado : false;

			if (permisao && !sync) {
				await this.checkGoogleSyncToButtonHidden();
			} else if (hasRecord && hasRecord.sincronizado) {
				$rootScope.emailGoogleAccount = true;
				$rootScope.emailGoogle = hasRecord.email;
				$rootScope.noSync = !hasRecord.sincronizado ? true : false;
			}
		};

		this.checkGoogleSyncToButtonHidden = async () => {
			const permissawait = permissions.has('recordSchedule');

			if (permissawait)
				await $http({
					...helper.http(API.agendaGoogleCalendar, 'GET'),
					params: {
						...helper.httpFields(['*']),
						sincronizado: true
					},
					messageOverride: {
						success() {}
					}
				}).then(async ({ data }) => {
					const active = data.itens.find(item => item.ativo);

					let { itens } = data;
					let sync = {};

					if (active) {
						$rootScope.emailGoogleAccount = true;

						sync = helper.cloneSimpleObject(itens[0]);

						let integracao = await this.GoogleAuthService.getIntegracaoGoogleCalendar(
							sync.integracaoGoogleCalendar.idIntegracaoGoogleCalendar
						);

						let syncGoogle = {};

						if (integracao != 'erro') {
							const missingScopes = requiredScopes.filter(
								scope => !integracao.scopes.includes(scope)
							);

							syncGoogle = {
								email: sync.agendaGoogleId,
								accessToken: integracao.accessToken,
								expiresData: transformDate.formatDate(
									integracao.expiresIn ? integracao.expiresIn : 3599,
									true
								),
								idAgendaGoogleCalendar: sync.idAgendaGoogleCalendar,
								idIntegracaoGoogleCalendar:
									sync.integracaoGoogleCalendar.idIntegracaoGoogleCalendar,
								scopes: integracao.scopes,
								missingScopes: !!missingScopes && missingScopes.length > 0
							};

							sync = syncGoogle;
							sync.sincronizado = true;
							$rootScope.emailGoogle = sync.email;
							$rootScope.noSync = !sync.sincronizado ? true : false;
						} else {
							syncGoogle = {
								error: true,
								email: sync.agendaGoogleId,
								idAgendaGoogleCalendar: sync.idAgendaGoogleCalendar,
								idIntegracaoGoogleCalendar:
									sync.integracaoGoogleCalendar.idIntegracaoGoogleCalendar
							};

							sync = syncGoogle;
						}
					} else {
						$rootScope.emailGoogleAccount = false;
						sync.sincronizado = false;
					}

					localStorage.setItem('__DataGoogleSync__', JSON.stringify(sync));
				});
		};

		this.initCodeClient = edit => {
			return new Promise((resolve, reject) => {
				$rootScope.loadingSync = true;

				// prettier-ignore
				const requestGoogleCode = () => {
				client = null;

				if (!client) {
					client = $window.google.accounts.oauth2.initCodeClient({
						'client_id': CLIENTID,
						scope: SCOPES,
						'ux_mode': 'popup',
						callback: async response => {
							const dataSyncGoogle = this.recoverInfos();
							const grantedScopes = response.scope ? response.scope.split(' ') : [];
							const missingScopes = requiredScopes.filter(scope => !grantedScopes.includes(scope));

							// Função auxiliar para lidar com cancelamento do usuário
							function handleUserCancellation() {
								notification.danger('Sincronização cancelada pelo usuário.');
								$('#inputGoogleCalendarModal').prop('checked', false);

								if ($rootScope.clicked) {
									$rootScope.sync = false;
									if ($rootScope.syncSuccess) {
										$rootScope.syncSuccess = false;
										notification.danger(
											'Os eventos anteriores não serão sincronizados. O processo foi cancelado pelo usuário!'
										);
									}
								}

								if (dataSyncGoogle.sincronizado) {
									this.disconnectSync(dataSyncGoogle.idAgendaGoogleCalendar);
								};

								$rootScope.loadingSync = false;
								reject({ error: 'access_denied' });
							}

							// Verifica se o usuário cancelou a sincronização
							if (response.error === 'access_denied') {
								handleUserCancellation();

								if (dataSyncGoogle.sincronizado) {
									this.disconnectSync(dataSyncGoogle.idAgendaGoogleCalendar);
								};

								return;
							}

							if (missingScopes.length > 0) {
								notification.danger(
									'Erro ao sincronizar eventos. É necessário <br>conceder as permissões no modal de integração do Google Agenda.'
								);
								$('#inputGoogleCalendarModal').prop('checked', false);
								$rootScope.sync = false;
								$rootScope.syncSuccess = false;
								$rootScope.loadingSync = false;
								if (dataSyncGoogle.sincronizado) {
									this.disconnectSync(dataSyncGoogle.idAgendaGoogleCalendar);
								};
								reject({ error: 'missing_scopes', missingScopes });

								return;
							}

							// Se todas as permissões forem concedidas, prossiga com a sincronização
							try {
								await this.GoogleAuthService.handleAuthResponse(response.code, edit);
								resolve();
							} catch (error) {
								notification.danger('Ocorreu um erro durante a sincronização. Por favor, tente novamente.');
								reject(error);
							}
						},
						'error_callback': error => {
							const dataSyncGoogle = this.recoverInfos();

							if (error.message == 'Popup window closed' || error.message == 'Failed to open popup window') {
								notification.danger('Sincronização cancelada pelo usuário.');
							}
							$('#inputGoogleCalendarModal').prop('checked', false);
							if ($rootScope.clicked) {
								$rootScope.sync = false;
								if ($rootScope.syncSuccess) {
									$rootScope.syncSuccess = false;
									notification.danger(
										'Os eventos anteriores não serão sincronizados. O processo foi cancelado pelo usuário!'
									);
								}
							}
							if (dataSyncGoogle.sincronizado) {
								this.disconnectSync(dataSyncGoogle.idAgendaGoogleCalendar);
							};
							$rootScope.loadingSync = false;
							reject(error);
						}
					});

					client.requestCode();
				} else {
					client.requestCode();
				}
				};

				if (
					$window.google &&
					$window.google.accounts &&
					$window.google.accounts.oauth2
				) {
					requestGoogleCode();
				} else {
					this.ensureGoogleIdentityLoaded()
						.then(requestGoogleCode)
						.catch(error => {
							$rootScope.loadingSync = false;
							reject(error);
						});
				}
			});
		};

		const service = this;

		this.GoogleAuthService = {
			handleAuthResponse: async function(response, edit) {
				await this.recordAgendas();

				if (window.location.origin === 'https://plataforma.advise.com.br') {
					var location = 'https://hub.advise.com.br';
				}

				await $http({
					...helper.http(API.agendaGoogleCalendar, 'sincronizar'),
					method: 'POST',
					data: {
						itens: [
							{
								idAgenda: $rootScope.idAgenda,
								authorizationCode: response,
								redirectUri: location ? location : window.location.origin
							}
						]
					},
					messageOverride: {
						success() {}
					}
				})
					.then(async response => {
						let sync = helper.cloneSimpleObject(response.data.itens[0]);

						const dataSyncGoogle = service.recoverInfos();

						const missingScopes = requiredScopes.filter(
							scope => !sync.scopes.includes(scope)
						);

						sync.sincronizado = true;
						//Formata tempo de expiração do token.
						sync.expiresData = transformDate.formatDate(sync.expiresIn, true);

						let agendaEvent = await this.getAgendaGoogleCalendar();

						let syncGoogle = {
							...sync,
							idAgendaGoogleCalendar: agendaEvent.idAgendaGoogleCalendar,
							idIntegracaoGoogleCalendar:
								agendaEvent.integracaoGoogleCalendar.idIntegracaoGoogleCalendar,
							scopes: dataSyncGoogle.scopes,
							missingScopes: !!missingScopes && missingScopes.length > 0
						};

						$rootScope.emailGoogleAccount = true;
						$rootScope.emailGoogle = sync.email;

						localStorage.setItem(
							'__DataGoogleSync__',
							JSON.stringify(syncGoogle)
						);

						notification.success('Google Agenda vinculada');
						$rootScope.sync = true;
						if ($rootScope.syncSuccess) {
							notification.success(
								'Os eventos anteriores serão sincronizados. Aguarde, essa operação pode levar alguns minutos!!'
							);

							let idUsuarioCliente =
								authentication.getUserData('idUsuarioCliente') || undefined;
							let idUsuarioInclusao =
								authentication.getUserData('idUsuarioCliente') || undefined;

							$('#modalSyncAgenda').modal('hide');
							$http({
								...helper.http(API.recoverPastDeadlines, 'POST'),
								data: {
									itens: [
										{
											idUsuarioCliente,
											idUsuarioInclusao
										}
									]
								}
							});
						}

						$rootScope.noSync = false;

						if (edit == 'editMoviments') $rootScope.checkMovementsNoSync();
						else if (edit == 'editDeadlines') $rootScope.checkDeadlinesNoSync();
						else if (edit == 'editDeadlinesDetails')
							$rootScope.checkDeadlinesDetailsNoSync();
					})

					.finally(() => {
						$rootScope.loadingSync = false;
					});
			},
			getAgendaGoogleCalendar: async function() {
				let data = {};

				await $http({
					...helper.http(API.agendaGoogleCalendar, 'GET'),
					params: {
						...helper.httpFields(['*']),
						SIncronizado: true
					}
				}).then(response => {
					data = response.data.itens[0];
				});

				return data;
			},
			getIntegracaoGoogleCalendar: async function(id) {
				let data = {};

				await $http({
					...helper.http(API.integracaoGoogleCalendar, 'GET'),
					params: {
						...helper.httpFields(['*']),
						idIntegracaoGoogleCalendar: id
					}
				})
					.then(response => {
						data = response.data.itens[0];
						$rootScope.sincronizacaoError = false;
					})
					.catch(() => {
						data = 'erro';
						$rootScope.sincronizacaoError = true;
					});

				return data;
			},
			recordAgendas: async function() {
				const idUsuarioCliente =
					parseInt(authentication.getUserData('idUsuarioCliente'), 10) ||
					undefined;

				await $http({
					...helper.http(API.agendas, 'GET'),
					params: {
						...helper.httpFields(['*']),
						idUsuarioCliente: idUsuarioCliente
					}
				})
					.then(response => {
						$rootScope.idAgenda = response.data.itens[0].id;
					})
					.catch(() => {
						$rootScope.creationEventLoading = false;
					});
			}
		};

		//Recupera dados de sincronização
		this.recoverInfos = () => {
			try {
				const data = localStorage.getItem('__DataGoogleSync__');

				if (!data) {
					return null;
				}

				return JSON.parse(data);
			} catch (error) {
				// eslint-disable-next-line
				console.error('Erro ao recuperar __DataGoogleSync__:', error);

				return null;
			}
		};

		//Recupera dados de sincronização
		this.notAgainSincGoogleAgenda = () => {
			const userParams = sessionStorage.getItem('parametros-usuarios');

			let record = {};

			if (!!userParams) {
				record = JSON.parse(userParams);
			}

			return record.sincGoogleAgenda;
		};

		/** Cria evento de agenda com movimento */
		this.sendEvent = (event, fields, form, type) => {
			return $http({
				...helper.http(API.deadlineEvents, 'POST'),
				data: { itens: [event] },
				messageOverride: {
					success(response, notify) {
						let idTipoEventoAgenda = -3;

						if (
							response &&
							response.data &&
							response.data.itens &&
							response.data.itens[0] &&
							response.data.itens[0].idTipoEventoAgenda
						) {
							idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
						}

						let nameType =
							idTipoEventoAgenda == -3
								? 'Compromisso'
								: idTipoEventoAgenda == -1
								? 'Tarefa'
								: 'Prazo';

						notify.success(
							`${nameType} cadastrad${
								idTipoEventoAgenda == -1 ? 'a' : 'o'
							} com sucesso.`
						);
					}
				}
			})
				.then(response => {
					if (response.data.itens)
						localStorage.setItem(
							'__agenda__',
							JSON.stringify(response.data.itens[0])
						);

					fields.map(inputKey =>
						helper.defer(() => {
							const $control = form[inputKey];

							if ($control) {
								switch (inputKey) {
									case 'idRepetEventoAgenda':
									case 'idOpcaoLembreteAgenda':
										$control.$setViewValue(-1);
										break;
									case 'idTipoCompromisso':
										$control.$setViewValue('');
										$control.$$ngModelSet('');
										$control.$$setModelValue('');
										break;
									case 'diaInteiro':
										$control.$setViewValue(false);
										$control.$$ngModelSet(false);
										$control.$$setModelValue(false);
										break;
									case 'dataHoraInicio':
										$control.$setViewValue(moment().format('DD/MM/YYYY'));
										break;
									case 'idTipoEventoAgenda':
									case 'idMovProcessoCliente':
										break;
									default:
										$control.$setViewValue('');
										break;
								}

								$control.$render();
							}
						})
					);

					$('#modalCreateAgendaEvent').modal('hide');

					const updateListModules = selector => {
						const iframe = document.querySelector(selector);

						if (!(iframe instanceof HTMLIFrameElement) || !iframe.contentWindow)
							return 'error';

						const msg = { type: 'UPDATE_LIST_INTIMATIONS' };

						iframe.contentWindow.postMessage(msg, '*');

						return 'ok';
					};

					const updateListModulesMov = selector => {
						const iframe = document.querySelector(selector);

						if (!(iframe instanceof HTMLIFrameElement) || !iframe.contentWindow)
							return 'error';

						const msg = { type: 'UPDATE_LIST_MOVEMENTS' };

						iframe.contentWindow.postMessage(msg, '*');

						return 'ok';
					};

					if (updateListModules('#module-intimation') == 'ok') return;
					if (updateListModulesMov('#module-movements') == 'ok') return;

					// prettier-ignore
					if (type == 'deadLines' &&
					!$state.includes('root.default.schedule.events'))
						setTimeout(() => {
							if (angular.isFunction($rootScope.setEachTabCounter)) {$rootScope.setEachTabCounter();}
							$state.go('root.default.deadlines.events.deadlineDetails', {
								eventId: response.data.itens[0].id,
								filtro: $state.params.filtro || 'vencendo',
								paginaAtual: $state.params.paginaAtual || 1
							});
						}, 1600);
				})
				.finally(() => {
					$rootScope.creationEventLoading = false;
					$rootScope.noSync = false;
				});
		};

		this.buildPayloadTask = (calendarObject, event) => {
			const formatTime = dateTime => {
				if (!dateTime) return '';

				return moment(dateTime).format('HH:mm');
			};

			const htmlToText = html => {
				if (!html) return '';

				const normalized = html
					.replace(/<br\s*\/?>/gi, '\n')
					.replace(/<\/p>/gi, '\n')
					.replace(/<\/div>/gi, '\n');

				const doc = new DOMParser().parseFromString(normalized, 'text/html');

				return (doc.body.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
			};

			const buildTitle = () => {
				if (event.diaInteiro) {
					return event.titulo;
				}

				const horaInicio = formatTime(event.dataHoraInicio);

				return horaInicio ? `${horaInicio} - ${event.titulo}` : event.titulo;
			};

			const buildDescription = () => {
				let horario;

				if (event.diaInteiro) {
					horario = 'Dia todo';
				} else {
					const horaInicio = formatTime(event.dataHoraInicio);
					const horaFim = formatTime(event.dataHoraFim);

					horario = horaFim ? `${horaInicio} às ${horaFim}` : horaInicio;
				}

				const horarioAdvise = `Horário no Advise Hub: ${horario}`;
				const observacao = htmlToText(event.observacao);

				if (observacao) {
					return `${horarioAdvise}\n\n${observacao}`;
				}

				return horarioAdvise;
			};

			delete calendarObject.description;
			delete calendarObject.summary;

			return {
				title: buildTitle(),
				notes: buildDescription(),
				due: event.dataHoraInicio.slice(0, 10) + 'T00:00:00-00:00'
			};
		};

		this.insertGoogleEvent = async (event, fields, form, type, fn) => {
			const dataInicioGoogle = event.diaInteiro
				? moment(event.dataHoraInicio).format('Y-MM-D')
				: new Date(moment(event.dataHoraInicio).format('YYYY-MM-DDTHH:mm:ss'));
			const dataFimGoogle = event.diaInteiro
				? moment(moment(event.dataHoraInicio).add(1, 'days')).format('Y-MM-D')
				: new Date(moment(event.dataHoraFim).format('YYYY-MM-DDTHH:mm:ss'));

			const eventGoogle = {
				summary: event.titulo,
				location: event.localizacao || '',
				description: event.observacao || ''
			};

			let calendarObject = {};

			if (event.diaInteiro) {
				calendarObject = {
					...eventGoogle,
					end: {
						date: dataFimGoogle,
						timeZone: 'America/Sao_Paulo'
					},
					start: {
						date: dataInicioGoogle,
						timeZone: 'America/Sao_Paulo'
					}
				};
			} else {
				calendarObject = {
					...eventGoogle,
					end: {
						dateTime: dataFimGoogle.toJSON(),
						timeZone: 'America/Sao_Paulo'
					},
					start: {
						dateTime: dataInicioGoogle.toJSON(),
						timeZone: 'America/Sao_Paulo'
					}
				};
			}

			//Recupera dados de sincronização
			let sync = this.recoverInfos();

			var dateNew = new Date();
			var dateExpires = new Date(sync.expiresData);
			var expires = dateExpires > dateNew ? false : true;

			if (expires) {
				let data = await this.GoogleAuthService.getIntegracaoGoogleCalendar(
					sync.idIntegracaoGoogleCalendar
				);

				sync.accessToken = data.accessToken;
				//Formata tempo de expiração do token
				sync.expiresData = transformDate.formatDate(sync.expiresIn, true);
				localStorage.setItem('__DataGoogleSync__', JSON.stringify(sync));
			}

			/*************** ENVIA DADOS PARA CADASTRO GOOGLE AGENDA **************/
			var xhr = new XMLHttpRequest();

			//Cadastro de prazos na agenda
			const addSendEvent = this.sendEvent;

			if (event.idTipoEventoAgenda == -1) {
				calendarObject = this.buildPayloadTask(calendarObject, event);
			}

			xhr.open(
				'POST',
				event.idTipoEventoAgenda === -1 ? url.tasks : url.events
			);
			xhr.setRequestHeader('Authorization', 'Bearer ' + sync.accessToken);
			xhr.setRequestHeader('Content-Type', 'application/json');
			xhr.onload = async function() {
				if (xhr.status !== 200) {
					let message = '';

					switch (xhr.status) {
						case 403:
							message =
								'Erro ao sincronizar evento. É necessário <br>conceder as permissões no modal de integração do Google Agenda.';
							break;

						default:
							message =
								'Erro ao sincronizar evento. <br>Acesse Minha Conta > Integrações e siga as instruções.';
							break;
					}

					notification.danger(message);
				} else if (xhr.status == 200) {
					var response = JSON.parse(xhr.responseText);
					var events = helper.cloneSimpleObject(event);

					events.eventoGoogleId = response.id;

					if (type !== 'edit') {
						await addSendEvent(events, fields, form, type);
					} else {
						fn();
					}
				}
			};

			xhr.send(JSON.stringify(calendarObject));
		};

		this.caseErrorTask = async (xhr, event, sync) => {
			// A recuperação vale somente para tarefas com erro HTTP 400.
			if (xhr.status !== 400 || event.idTipoEventoAgenda !== -1) {
				return false;
			}

			let data;

			try {
				data = JSON.parse(xhr.responseText);
			} catch (error) {
				return false;
			}

			const message = data && data.error && data.error.message;

			if (typeof message !== 'string' || !message.includes('Invalid task ID')) {
				return false;
			}

			if (!sync || !sync.accessToken) {
				throw new Error('Token de acesso ao Google não disponível.');
			}

			// Monta a nova tarefa com os dados editados, sem enviar o ID antigo.
			const payload = this.buildPayloadTask({}, event);

			const task = await new Promise((resolve, reject) => {
				// Uma nova requisição, sem reutilizar o xhr do PUT.
				const xhrInsert = new XMLHttpRequest();

				xhrInsert.open('POST', url.tasks);
				xhrInsert.setRequestHeader(
					'Authorization',
					'Bearer ' + sync.accessToken
				);
				xhrInsert.setRequestHeader('Content-Type', 'application/json');
				xhrInsert.timeout = 30000;

				xhrInsert.onload = () => {
					if (xhrInsert.status < 200 || xhrInsert.status >= 300) {
						reject(
							new Error(
								`Erro ao criar tarefa no Google. HTTP ${xhrInsert.status}.`
							)
						);

						return;
					}

					try {
						const response = JSON.parse(xhrInsert.responseText);

						if (!response || !response.id) {
							throw new Error('O Google não retornou o ID da tarefa criada.');
						}

						resolve(response);
					} catch (error) {
						reject(error);
					}
				};

				xhrInsert.onerror = () => {
					reject(new Error('Falha de rede ao criar a tarefa no Google.'));
				};

				xhrInsert.ontimeout = () => {
					reject(new Error('Tempo esgotado ao criar a tarefa no Google.'));
				};

				xhrInsert.onabort = () => {
					reject(new Error('Criação da tarefa no Google cancelada.'));
				};

				xhrInsert.send(JSON.stringify(payload));
			});

			// Atualiza o objeto original que será utilizado na edição.
			event.eventoGoogleId = task.id;

			return true;
		};

		this.updateGoogleEvent = async (event, fn) => {
			const dataInicioGoogle = event.diaInteiro
				? moment(event.dataHoraInicio).format('Y-MM-D')
				: new Date(moment(event.dataHoraInicio).format('YYYY-MM-DDTHH:mm:ss'));
			const dataFimGoogle = event.diaInteiro
				? moment(moment(event.dataHoraInicio).add(1, 'days')).format('Y-MM-D')
				: new Date(moment(event.dataHoraFim).format('YYYY-MM-DDTHH:mm:ss'));

			const eventGoogle = {
				summary: event.titulo,
				location: event.localizacao || '',
				description: event.observacao || ''
			};

			let calendarObject = {};

			if (event.diaInteiro) {
				calendarObject = {
					...eventGoogle,
					end: {
						date: dataFimGoogle,
						timeZone: 'America/Sao_Paulo'
					},
					start: {
						date: dataInicioGoogle,
						timeZone: 'America/Sao_Paulo'
					}
				};
			} else {
				calendarObject = {
					...eventGoogle,
					end: {
						dateTime: dataFimGoogle.toJSON(),
						timeZone: 'America/Sao_Paulo'
					},
					start: {
						dateTime: dataInicioGoogle.toJSON(),
						timeZone: 'America/Sao_Paulo'
					}
				};
			}

			//Recupera dados de sincronização
			let sync = this.recoverInfos();

			var dateNew = new Date();
			var dateExpires = new Date(sync.expiresData);
			var expires = dateExpires > dateNew ? false : true;

			if (expires) {
				let data = await this.GoogleAuthService.getIntegracaoGoogleCalendar(
					sync.idIntegracaoGoogleCalendar
				);

				sync.accessToken = data.accessToken;
				//Formata tempo de expiração do token
				sync.expiresData = transformDate.formatDate(sync.expiresIn, true);
				localStorage.setItem('__DataGoogleSync__', JSON.stringify(sync));
			}

			if (event.idTipoEventoAgenda == -1) {
				calendarObject = {
					...this.buildPayloadTask(calendarObject, event),
					id: event.eventoGoogleId
				};
			}

			/*************** ENVIA DADOS PARA CADASTRO GOOGLE AGENDA **************/
			var xhr = new XMLHttpRequest();

			xhr.open(
				'PUT',
				`${event.idTipoEventoAgenda === -1 ? url.tasks : url.events}/${
					event.eventoGoogleId
				}`
			);
			xhr.setRequestHeader('Authorization', 'Bearer ' + sync.accessToken);
			xhr.setRequestHeader('Content-Type', 'application/json');
			xhr.onload = async () => {
				try {
					if (xhr.status >= 200 && xhr.status < 300) {
						// O update no Google funcionou normalmente.
						const response = JSON.parse(xhr.responseText);

						if (!response || !response.id) {
							throw new Error('O Google não retornou o ID do item atualizado.');
						}

						event.eventoGoogleId = response.id;
					} else {
						// Retorna true somente se era o erro específico
						// e a nova tarefa foi criada com sucesso.
						const recreated = await this.caseErrorTask(xhr, event, sync);

						if (!recreated) {
							const message =
								xhr.status === 403
									? 'Erro ao sincronizar evento. É necessário <br>conceder as permissões no modal de integração do Google Agenda.'
									: 'Erro ao sincronizar evento. <br>Acesse Minha Conta > Integrações e siga as instruções.';

							notification.danger(message);

							return;
						}
					}
				} catch (error) {
					// eslint-disable-next-line
					console.error(error);

					notification.danger(
						'Não foi possível concluir a sincronização com o Google.'
					);

					return;
				}

				// Chega aqui somente se:
				// 1. O PUT funcionou; ou
				// 2. A tarefa foi recriada e event já recebeu o novo ID.
				try {
					// Continua o fluxo original da edição.
					// Não substitui o payload nem altera identificadores locais.

					debugger;
					await fn();
				} catch (error) {
					// eslint-disable-next-line
					console.error('Erro ao finalizar a edição no sistema:', {
						eventoGoogleId: event.eventoGoogleId,
						status: error && error.status,
						resposta: error && error.data,
						mensagem: error && error.message
					});

					notification.danger(
						'A sincronização com o Google foi concluída, ' +
							'mas ocorreu um erro ao finalizar a edição no sistema.'
					);
				}
			};

			xhr.onerror = () => {
				notification.danger('Falha de rede ao atualizar o item no Google.');
			};

			xhr.send(JSON.stringify(calendarObject));
		};

		this.deleteGoogleEvent = async (event, vencido, fn) => {
			//Recupera dados de sincronização
			let sync = this.recoverInfos();

			var dateNew = new Date();
			var dateExpires = new Date(sync.expiresData);
			var expires = dateExpires > dateNew ? false : true;

			if (expires) {
				let data = await this.GoogleAuthService.getIntegracaoGoogleCalendar(
					sync.idIntegracaoGoogleCalendar
				);

				sync.accessToken = data.accessToken;
				//Formata tempo de expiração do token
				sync.expiresData = transformDate.formatDate(sync.expiresIn, true);
				localStorage.setItem('__DataGoogleSync__', JSON.stringify(sync));
			}

			var xhr = new XMLHttpRequest();

			xhr.open(
				'DELETE',
				`${event.idTipoEventoAgenda === -1 ? url.tasks : url.events}/${
					event.eventoGoogleId
				}`
			);
			xhr.setRequestHeader('Authorization', 'Bearer ' + sync.accessToken);
			xhr.onload = function() {
				if (xhr.status === 204 && vencido) {
					fn();
				}
			};
			xhr.send();
		};

		this.disconnectSync = async id => {
			await $http({
				...helper.http(API.agendaGoogleCalendar, 'dessincronizar'),
				method: 'PUT',
				data: {
					itens: [
						{
							idAgendaGoogleCalendar: id
						}
					]
				},
				messageOverride: {
					success() {}
				}
			}).then(async () => {
				notification.success('Google Agenda dessincronizada!');
				$rootScope.emailGoogleAccount = false;
				$rootScope.sync = false;

				let sync = {
					sincronizado: false
				};

				localStorage.setItem('__DataGoogleSync__', JSON.stringify(sync));
			});
		};
	}
]);
